import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-6 text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl flex items-center gap-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Current Preferences", -1)
const _hoisted_3 = { class: "grid w-full grid-cols-1 gap-6 sm:grid-cols-2" }
const _hoisted_4 = { class: "rounded-lg text-card-foreground shadow-sm px-1 bg-gray-50 flex flex-col items-center justify-center text-center border-2 border-dashed border-gray-200" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col space-y-1.5 p-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "tracking-tight text-2xl font-bold" }, "Request Personal Quote")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-6 pt-0 -my-2 -mt-3 max-w-xs mx-auto text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Request a personal quote from Jessica for your deal.")
], -1)
const _hoisted_7 = { class: "p-6 pt-0 flex items-center justify-center mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArchiveIcon = _resolveComponent("ArchiveIcon")!
  const _component_OriginatorCreditBox = _resolveComponent("OriginatorCreditBox")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h2", _hoisted_1, [
      _createVNode(_component_ArchiveIcon, { class: "inline-block h-9 w-9" }),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originator.CreditBoxes, (value, name) => {
        return (_openBlock(), _createBlock(_component_OriginatorCreditBox, {
          name: name,
          key: name,
          "credit-box": value
        }, null, 8, ["name", "credit-box"]))
      }), 128)),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background border border-input hover:bg-accent hover:text-accent-foreground h-10 py-2 px-4",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('ModalGetQuotePublic')))
          }, " Request a Quote   → ")
        ])
      ])
    ])
  ]))
}